module.exports = __webpack_public_path__ + "5fdca0a72071ff8789eca3b4b6d963c1.svg";